<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAllDamageList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content @click="exportAllDamage()">
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Invoice No"
                type="text"
                v-model="queryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.role.roleName == 'ADMIN' ||
                user.role.roleName == 'FINANCE_MANAGER' ||
                user.role.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                color="blue-grey lighten-2"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="invoiceTypeList"
                label="Invoice Type"
                v-model="queryParams.invoiceType"
                item-text="label"
                item-value="value"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Amount :</span>
              <v-chip>
                <span>{{ totalDamageAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="damageList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{
                  props.item.updatedDateInMilliSeconds | format-ms-date
                }}
              </td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.customerDTO.name }}</td>
              <td>{{ props.item.customerDTO.code }}</td>
              <td>{{ props.item.shopDTO.name }}</td>
              <td>{{ props.item.invoiceType }}</td>
              <td>{{ props.item.damageStatus }}</td>
              <td>{{ props.item.shopDTO.regionName }}</td>
              <td style="text-align: right">
                {{ props.item.totalAmount | decFormat(6) }}
              </td>
              <td>{{ props.item.remark }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <damage report> -->
    <div
      id="printAllDamageList"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          Damage Sale Return (Not Approved)
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Invoice Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Invoice No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Price</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody v-for="(header, index) in allDamageList" :key="index">
            <tr v-for="(item, i) in header.damageDetailList" :key="i">
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.updatedDateInMilliSeconds | format-ms-date }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.invoiceNo }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.customerDTO.name }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.price | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ (item.price * item.qty) | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="7"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ header.totalPrice | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="7"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ totalDamageAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { shopService } from "../../services/shop-service";
import { damageService } from "../../services/damage-service";
import { commonService } from "../../services/common-service";

export default {
  name: "DamageSaleNotApprovedReport",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Damage Sale (Not Approved) Report",
        disabled: true,
      },
    ],
    headers: [
      {
        text: "Invoice Date",
        align: "left",
        value: "warehouse.name",
        sortable: false,
      },
      { text: "Invoice No", align: "left", value: "bin.name", sortable: false },
      { text: "Customer Name", value: "issueDate", sortable: false },
      { text: "Customer Code", value: "issueNo", sortable: false },
      { text: "Shop Name", value: "poNo", sortable: false },
      { text: "Invoice Type", value: "invoiceType", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Region", value: "description", sortable: false },
      { text: "Total Damage Amount", value: "updatedDate", sortable: false },
      { text: "Remark", align: "center", sortable: false },
      { text: "Updated  By", value: "updatedBy", sortable: false },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      invoiceNo: "",
      customerName: "",
      customerCode: "",
      shopId: "",
      status: "",
      invoiceType: "",
    },
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    totalDamageAmount: 0,
    totalAmount: 0,
    totalRows: 0,
    showListLoading: false,
    buttonLoading: false,
    printAllButtonLoading: false,
    clonequeryParams: new Object(),
    shopList: [],
    damageList: [],
    allDamageList: [],
    decimalFormat: "",
    invoiceTypeList: [{ label: "ALL", value: "" }],
  }),
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.invoiceNo) {
      this.queryParams.invoiceNo = this.$route.query.invoiceNo;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.invoiceType) {
      this.queryParams.invoiceType = this.$route.query.invoiceType;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.queryParams.status = "DRAFT";
    this.onSearch();
    this.getAllShop();
    this.getAllInvoiceType();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "damage-sale-not-approved-report",
        query: this.queryParams,
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getDamageList();
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getDamageList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      damageService
        .getDamageList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.damageList = res.data.damageHeaderList;
            this.totalRows = res.data.totalElements;
            this.totalDamageAmount = res.data.totalDamageAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAll(divName) {
      this.printAllButtonLoading = true;
      damageService
        .getAllDamageList(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allDamageList = res.data.damageHeaderList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    exportAllDamage() {
      this.printAllButtonLoading = true;
      damageService
        .exportAllDamageHeaderDetailExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        });
      this.printAllButtonLoading = false;
    },
    getAllInvoiceType() {
      damageService
        .getAllDamageInvoiceType()
        .then((res) => {
          let tempList = res.data;
          tempList.forEach((item) => {
            let tempObj = { label: item, value: item };
            this.invoiceTypeList.push(tempObj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>